import { EmptyStatePrimaryAction } from '@synoptic/ui-kit/empty-state/empty-state-primary-action.tsx';
import { EmptyState } from '@synoptic/ui-kit/empty-state/empty-state.tsx';
import { ShareAndroidIcon } from '@synoptic/ui-kit/icons/react/share-android.tsx';
import { useParams } from 'react-router';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useIsMe } from '@/routes/_app.$username/use-is-me.ts';
import { emptyProfileStreamList } from './empty-profile-stream-list.css.ts';

export const EmptyStreamList = () => {
  const username = useParams().username as string;
  const isMe = useIsMe();
  const description = isMe
    ? `This is where you'll be able to see data streams you created.`
    : `This is where you'll be able to see data streams by @${username}.`;

  return (
    <EmptyState
      illustration={<ShareAndroidIcon />}
      heading={'No streams yet'}
      description={description}
      action={
        <EmptyStatePrimaryAction asChild>
          <Link to={paths.streams}>Explore streams</Link>
        </EmptyStatePrimaryAction>
      }
      className={emptyProfileStreamList}
    />
  );
};
